module.exports = __webpack_public_path__ + "static/media/fingernail_right.b83c01df.svg";